import classNames from 'classnames';
import React, { useContext } from 'react';
import context from '../../../../../../../hoc/context/product/context';
import { RadioButton } from '../../../../../../../hoc/components/inputs';
import { QuestionChoice } from '../../../../../../../hoc/context/product/context-model';
import { ChoiceDescriptionViewer } from '../../../../choice-description/choice-description';

interface ChoiceProps {
	choice: QuestionChoice;
	currentAnswer: string | undefined;
	onClick: Function;
}

export const Choice: React.FC<ChoiceProps> = ({
	choice,
	currentAnswer,
	onClick,
}) => {
	const ctxt = useContext(context);
	const printLabel = (questionChoice: QuestionChoice) => {
		if (questionChoice.label) {
			return questionChoice.label;
		}
		return questionChoice.value
			? ctxt.json.pages.questions.yes
			: ctxt.json.pages.questions.no;
	};
	return (
		<div className={`w-full`} data-testid="choice-component">
			<RadioButton
				id={choice.value.toString()}
				label={printLabel(choice)}
				name={choice.value.toString()}
				checked={currentAnswer === choice.value}
				onChange={() => {
					onClick(choice);
				}}
				className={classNames('', {
					'ring-2 ring-brand': currentAnswer === choice.value,
				})}
			/>
			{choice.description && (
				<div className="mt-7 pl-6 pr-6 lg:pl-14 lg:pr-0">
					<ChoiceDescriptionViewer description={choice.description} />
				</div>
			)}
		</div>
	);
};
